"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var typeChecks_1 = require("./typeChecks");
function isArrayLike(obj) {
  return Array.isArray(obj) || isObservableArray(obj);
}
exports.isArrayLike = isArrayLike;
function isObservableArray(obj) {
  return typeof obj !== 'string' && !typeChecks_1.isNullOrUndefined(obj) && !typeChecks_1.isNullOrUndefined(obj.length) && !typeChecks_1.isNullOrUndefined(obj.slice) && typeof obj.slice === 'function';
}
exports.isObservableArray = isObservableArray;